import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/tags',
  component: Management,
  redirect: '/tags/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/tags/List'),
      redirect: 'list/users',
      meta: {
        auth: Auth.listTags
      },
      children: [
        {
          path: 'users',
          component: () => import('@/views/tags/ListTable'),
          meta: {
            auth: Auth.listTags,
            tabName: 'users'
          }
        },
        {
          path: 'products',
          component: () => import('@/views/tags/ListTable'),
          meta: {
            auth: Auth.listTags,
            tabName: 'products'
          }
        },
        {
          path: 'station_comments',
          component: () => import('@/views/tags/ListTable'),
          meta: {
            auth: Auth.listTags,
            tabName: 'station_comments'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/tags/New'),
      meta: {
        auth: Auth.createTag
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/tags/Edit'),
      meta: {
        auth: Auth.updateTag
      }
    }
  ]
}
